import { Container, ContentHeader, Page } from 'components'
import { RemoveForm } from './components/Remove'

const DataProcessesRemove = () => {
  return (
    <Page title="Excluir Processos">
      <Container
        maxWidth={false}
        spacingXl={20}
        spacingLg={15}
        spacingMd={10}
        spacingSm={5}
        spacingXs={5}
      >
        <ContentHeader
          menu="Processos"
          title="Remover"
          subtitle="Remover Processos"
        />
        <RemoveForm />
      </Container>
    </Page>
  )
}

export default DataProcessesRemove
